export const URI = process.env.REACT_APP_URI
	// 'https://gql.indigomental.com/'
